import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App, { TabErrorBoundary } from './App';
import VersionBanner from './VersionBanner';
import SiteGate from './SiteGate';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TabErrorBoundary fullPage>
      <SiteGate>
        <VersionBanner />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SiteGate>
    </TabErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
